module.exports = __webpack_public_path__ + "static/media/Product Design & Manufacturing.6f3a2a30.png";